import { render } from "./404.vue?vue&type=template&id=ebe0e774&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=ebe0e774&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ebe0e774"

export default script